import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ResumeService {
  constructor(private http: HttpClient) { }

  //jeb don't need a get?!
  //public refreshCurrentUser(): User {
  //  let user = this.getCurrentUser();
  //  if (!user) {
  //    return null;
  //  }

  //  this.http.get('/api/portal/users/' + user.email)
  //    .subscribe((user: User) => {
  //      if (user) {
  //        localStorage.setItem(this.MatrixToolsUserKey, JSON.stringify(user));
  //        return user;
  //      }
  //      return null;
  //    });
  //}

  public generateResume(id: string, color: string, resume: FormData) {
    return this.http.post(`/api/resume/create/${id}/${color}`, resume)
      .pipe(map(createdResumeId => {
        return createdResumeId;
      }));
  }
}
